
import AppContainer from "~/components/common/AppContainer.vue";

export default {
  name: "HtmlSectionV2",

  components: { AppContainer },

  inject: { pageType: { default: "" } },

  props: { slice: { type: Object, required: true } },

  data: () => ({ newScript: null }),

  head() {
    return { script: this.slice.primary.src ? this.scripts : [] };
  },

  computed: {
    scripts() {
      return [
        {
          hid: `html-section-v2-${this.slice.primary.src}`,
          src: this.slice.primary.src,
          type: this.slice.primary.type,
          defer: true,
          pbody: true,
          callback: () => {
            this.runScript();
          },
        },
      ];
    },
    componentToRender() {
      return this.pageType === "Collection_page" ? "AppContainer" : "div";
    },
  },

  mounted() {
    if (!this.slice.primary.src) {
      this.runScript();
    }
  },

  destroyed() {
    if (this.newScript) {
      document.head.removeChild(this.newScript);
    }
  },

  methods: {
    runScript() {
      this.$nextTick(() => {
        this.reRunScript();
      });
    },

    /**
    The script content added through innerHTML doesn't run
    so we have to create a script tag with the old script content
    */

    reRunScript() {
      const scripts = this.$refs?.htmlSection?.querySelectorAll("script") ?? [];
      Array.from(scripts).forEach(oldScript => {
        this.newScript = document.createElement("script");
        this.newScript.id = "html-section-script";
        Array.from(oldScript.attributes).forEach(attr =>
          this.newScript.setAttribute(attr.name, attr.value)
        );

        this.newScript.appendChild(
          document.createTextNode(oldScript.innerHTML)
        );

        document.head.appendChild(this.newScript);
        // oldScript.parentNode.replaceChild(this.newScript, oldScript);
      });
    },
  },
};
